import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d4cb55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#eaeaea"} }, "Navigation Tools", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPlace(0))),
      class: "button button0"
    }, "工厂"),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoPlace(1))),
      class: "button button1"
    }, "静子车间"),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoPlace(2))),
      class: "button button2"
    }, "转子车间"),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotoPlace(3))),
      class: "button button3"
    }, "联合车间"),
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoPlace(4))),
      class: "button button4"
    }, "涂装车间"),
    _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotoPlace(5))),
      class: "button button5"
    }, "配送车间"),
    _createElementVNode("button", {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gotoPlace(6))),
      class: "button button6"
    }, "总装车间")
  ]))
}